/**
 * @generated SignedSource<<07340e526b763ffd628239b0869e387b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceProductSearchItem_workspaceProductSearchHit$data = {
  readonly id: string | null;
  readonly nameHighlights: ReadonlyArray<{
    readonly isHighlighted: boolean;
    readonly text: string;
  }> | null;
  readonly product: {
    readonly id: string;
    readonly imageUrl: string | null;
    readonly name: string | null;
    readonly partNumber: string | null;
  };
  readonly " $fragmentType": "WorkspaceProductSearchItem_workspaceProductSearchHit";
};
export type WorkspaceProductSearchItem_workspaceProductSearchHit$key = {
  readonly " $data"?: WorkspaceProductSearchItem_workspaceProductSearchHit$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceProductSearchItem_workspaceProductSearchHit">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceProductSearchItem_workspaceProductSearchHit",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "WorkspaceProductSearchHitHighlightPart",
      "kind": "LinkedField",
      "name": "nameHighlights",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isHighlighted",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WorkspaceProduct",
      "kind": "LinkedField",
      "name": "product",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "partNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WorkspaceProductSearchHit",
  "abstractKey": null
};
})();

(node as any).hash = "61ff3f0749474678fa45f0a10ffe1cab";

export default node;
